class Note {
    constructor(candidateId, description) {
        this.candidateId = candidateId
        this.description = description
    }
}

export default Note